import axios, { AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios';
import { AxiosRequestConfig, AxiosError } from 'axios';
import { NavigateFunction } from 'react-router-dom';

export const setupAxiosInterceptors = (navigate: NavigateFunction) => {
  // Intercettore della richiesta
  const requestInterceptor = axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const token = localStorage.getItem('accessToken');
      if (token && config.headers) {
        (config.headers as AxiosRequestHeaders).Authorization = `Bearer ${token}`;
      }
      return config as InternalAxiosRequestConfig<any>;
    },
    (error: AxiosError) => Promise.reject(error)
  );

  // Intercettore della risposta
  const responseInterceptor = axios.interceptors.response.use(
    response => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        // Reindirizza alla login
        navigate('/');
      }
      return Promise.reject(error);
    }
  );

  // Funzione di cleanup per rimuovere gli intercettori
  return () => {
    axios.interceptors.request.eject(requestInterceptor);
    axios.interceptors.response.eject(responseInterceptor);
  };
};
